import { render, staticRenderFns } from "./materiallist.vue?vue&type=template&id=164053a5&"
import script from "./materiallist.vue?vue&type=script&lang=js&"
export * from "./materiallist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports